export const CITIES = [
    {
        name: 'Minsk',
        lat: 53.9,
        lon: 27.5667
    },
    {
        name: 'Moscow',
        lat: 55.7522,
        lon: 37.6156
    },
    {
        name: 'Bratislava',
        lat: 48.1482,
        lon: 17.1067
    }
]